<section class="container">
  <section class="heading" data-testid="active-state-title">
    <app-dot-pulse />
    <p class="body bold">{{ vm.panelTitle }}</p>
  </section>

  <section>
    @if (vm.appointmentDate) {
      <p class="body">
        They'll arrive on {{ vm.appointmentDate | date: 'EEEE d MMMM yyyy' }}. <br />{{ vm.confirmationMessage }}
      </p>
    } @else if (vm.confirmationMessage) {
      <p class="body">{{ vm.confirmationMessage }}</p>
    }

    <p
      class="body mb-8"
      [class.mt-8]="!!vm.confirmationMessage"
      [class.bold]="!vm.isEsOrJSTElectronics || vm.isProductFromGame || vm.isGadget"
    >
      The next steps are:
    </p>
    <ul class="mb-8">
      @for (step of vm.nextSteps; track step) {
        <li>
          <p class="body">{{ step }}</p>
        </li>
      }
    </ul>

    @if (vm.isGadget && !vm.isProductFromGame) {
      <p class="body" data-testid="exchange-note">
        <span class="bold">If it's an exchange</span>, they'll deliver the replacement and collect the faulty product.
      </p>
    }

    @if (vm.isProductFromGame) {
      <p class="body mt-8" data-testid="game-collect-replace-note">
        <span class="bold">If you chose collect and replace</span>, your item will be assessed and a replacement sent to
        you — usually within 3 working days. Your replacement will be brand new or Grade A refurbished.
      </p>
    }
  </section>
</section>
